import { render, staticRenderFns } from "./launcherRealeaseList.vue?vue&type=template&id=a5663722&scoped=true"
import script from "./launcherRealeaseList.vue?vue&type=script&lang=js"
export * from "./launcherRealeaseList.vue?vue&type=script&lang=js"
import style0 from "./launcherRealeaseList.vue?vue&type=style&index=0&id=a5663722&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5663722",
  null
  
)

export default component.exports